import { IonContent, IonHeader, IonPage, IonTitle, IonToolbar, useIonViewDidEnter } from '@ionic/react'
import React from 'react'

const Volunteer: React.FC = () => {
    useIonViewDidEnter(() => {
        const a = document.createElement('a')
        a.href = 'https://forms.gle/xd36XSkS39gcbDaz6'
        document.body.appendChild(a)
        a.click()
        document.body.removeChild(a)
    })
    return (
        <IonPage>
            <IonContent></IonContent>
        </IonPage>
    )
}

export default Volunteer